import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CaixaContextStore } from './caixa-context.store';

export const caixaContextInterceptor: HttpInterceptorFn = (req, next) => {
  const ctx = inject(CaixaContextStore);

  if (ctx.idCaixa != null && ctx.idUsuario != null) {
    req = req.clone({
      setHeaders: {
        'X-Caixa-Id': String(ctx.idCaixa),
        'X-Usuario-Id': String(ctx.idUsuario),
      },
    });
  }

  return next(req);
};
